module.exports = __webpack_public_path__ + "98a60333f07e30c0010dec6b93e3b18c.fbx";